/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable prettier/prettier */
import { Container } from '@plone/components';
import LOGO from '../../assets/logo_flanders.svg';
import LOGO_DARK from '../../assets/logo_flanders_dark.svg';
import LOGO_FLANDERS from '../../assets/logo_flanders-state-of-the-art.svg';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  OfficialWebsite: {
    id: 'OfficialWebsite',
    defaultMessage:
      'Flanders Environment Agency is an official website of the Flemish government',
  },
  PublishedBy: {
    id: 'PublishedBy',
    defaultMessage: 'Published by',
  },
  Privacy: {
    id: 'Privacy',
    defaultMessage: 'Privacy',
  },
  CookiePolicy: {
    id: 'CookiePolicy',
    defaultMessage: 'Cookie policy',
  },
  Accessibility: {
    id: 'Accessibility',
    defaultMessage: 'Accessibility',
  },
  Dutch: {
    id: 'Dutch',
    defaultMessage: 'NL',
  },
  English: {
    id: 'English',
    defaultMessage: 'EN',
  },
  logoFlandersSotA: {
    id: 'Logo Flanders State of the Art',
    defaultMessage: 'Logo Flanders State of the Art',
  },
});

export const FlandersFooter = () => {
  const intl = useIntl();

  return (
    <div className="flanders-footer footer">
      <Container layout className="flanders-footer__container">
        <img
          src={intl.locale === 'en' ? LOGO_FLANDERS : LOGO}
          alt={intl.formatMessage(messages.logoFlandersSotA)}
          className="flanders-footer__logo desktop"
        />
        <img
          src={intl.locale === 'en' ? LOGO_FLANDERS : LOGO_DARK}
          alt={intl.formatMessage(messages.logoFlandersSotA)}
          className="flanders-footer__logo mobile"
        />
        <div className="flanders-footer__content">
          <h2>{intl.formatMessage(messages.OfficialWebsite)}</h2>
          <p>
            {intl.formatMessage(messages.PublishedBy)}{' '}
            <a href="https://vmm.vlaanderen.be">VMM</a>
          </p>
          <div className="flanders-footer__links">
            <a href="/privacy">{intl.formatMessage(messages.Privacy)}</a>
            <a href="/cookie-policy">
              {intl.formatMessage(messages.CookiePolicy)}
            </a>
            <a href="/toegankelijkheid">
              {intl.formatMessage(messages.Accessibility)}
            </a>
          </div>
        </div>
        <div className="flanders-footer__languages">
          <a href="https://vmm.vlaanderen.be">
            {intl.formatMessage(messages.Dutch)}
          </a>
          <a href="https://vmm.vlaanderen.be/en">
            {intl.formatMessage(messages.English)}
          </a>
        </div>
      </Container>
    </div>
  );
};
